<ion-content>
  <div class="center-content">
    <ion-button (click)="onReload()">
      <ion-icon class="reload-icon" name="sync-outline" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</ion-content>
